import { Person } from "@models/person.model";
import { CommandAddProfilePicture } from "./commands/CmdAddProfilePicture";
import { CommandCreatePerson } from "./commands/CmdCreatePerson";
import { CommandDeleteProfilePicture } from "./commands/CmdDeleteProfilePicture";

export class PersonService {
  async addProfilePicture(personId: number, file: File) {
    const cmd = new CommandAddProfilePicture();
    const results = await cmd.run(personId, file);
    return results;
  }
  async deleteProfilePicture(personId: number) {
    const cmd = new CommandDeleteProfilePicture();
    const results = await cmd.run(personId);
    return results;
  }
  async createPerson(person: Person, file?: File) {
    const cmd = new CommandCreatePerson();
    const results = await cmd.run(person, file);
    return results;
  }
}
